import React, { useState } from 'react'
import { converter } from 'src/Utils/ShowDownConverter'
import ReactMde from 'react-mde'
import {
  RichTextboxLabel,
  RichTextEditorContainer,
} from './NewRichTextEditor.styles'

export interface NewRichTextEditorProps {
  value: string
  onChange: (value: string) => void
  label?: string
}

export const NewRichTextEditor = (
  props: NewRichTextEditorProps,
): JSX.Element => {
  const [selectedTab, setSelectedTab] = useState<'write' | 'preview'>('write')

  return (
    <RichTextEditorContainer>
      {props.label && <RichTextboxLabel>{props.label}</RichTextboxLabel>}
      <ReactMde
        value={props.value}
        onChange={props.onChange}
        selectedTab={selectedTab}
        onTabChange={setSelectedTab}
        generateMarkdownPreview={(markdown) =>
          Promise.resolve(converter.makeHtml(markdown))
        }
      />
    </RichTextEditorContainer>
  )
}
